// import ReactDOM from "react-dom/client";
// import App from "./App";
// import { Home } from "./routes/Home/Home";
// import { createBrowserRouter, RouterProvider } from "react-router-dom";
// import { Terms } from "./routes/Terms/Terms";
// import { Contato } from "./routes/Contact/Contact";
// import "./index.css";
// import { About } from "./routes/About/About";
// import { Login } from "./routes/account/Login";
// import { Occupation } from "./routes/Occupation/Occupation";
// import News from "./routes/News/News";
// import Consumer from "./routes/Occupation/Consumer/Consumer";
// import Air from "./routes/Occupation/Air/Air";
// import Digital from "./routes/Occupation/Digital/Digital";
// import Social from "./routes/Occupation/Social/Social";
// import { Dashboard } from "./routes/Dashboard/Dashboard";
// import { Privacy } from "./routes/Privacy/Privacy";
// import NewsPage from "./routes/News/NewsPage";
// import { ProtectedRoute } from "./routes/ProtectedRoute";

// import { ResetPasswordPage } from "./routes/account/ResetPasswordPage";
// import React from "react";
// import DataDeletion from "./routes/DateDeletion/DataDeletion";
// import { LandingPage } from "./routes/Landing/LandingPage";
// import LinktreeCard from "./routes/Linktree/LinktreeCard";
// import SocialSecurity from "./routes/Occupation/SocialSecurity/SocialSecurity";
// import Planning from "./routes/Occupation/Planning/Planning";
// import { HelmetProvider } from "react-helmet-async";

// // eslint-disable-next-line react-refresh/only-export-components
// const Routes = () => {
//   const router = createBrowserRouter([
//     {
//       path: "/",
//       element: <App />,
//       children: [
//         { path: "/", element: <Home /> },
//         { path: "/escritorio", element: <About /> },
//         { path: "/terms", element: <Terms /> },
//         { path: "/politica-privacidade", element: <Privacy /> },
//         { path: "/contato", element: <Contato /> },
//         { path: "/login", element: <Login /> },
//         { path: "/resetar-senha", element: <ResetPasswordPage /> },
//         { path: "/area-atuacao", element: <Occupation /> },
//         { path: "/noticias", element: <News /> },
//         { path: "/direito-consumidor", element: <Consumer /> },
//         { path: "/direito-aereo", element: <Air /> },
//         { path: "/direito-digital", element: <Digital /> },
//         { path: "/direito-saude", element: <Social /> },
//         { path: "/direito-previdenciario", element: <SocialSecurity /> },
//         { path: "/planejamento-previdenciario", element: <Planning /> },
//         { path: "/landing-page", element: <LandingPage /> },
//         {
//           path: "/dashboard",
//           element: (
//             <ProtectedRoute>
//               <Dashboard />
//             </ProtectedRoute>
//           ),
//         },
//         { path: "/deletar-dados", element: <DataDeletion /> },
//         { path: "/pagina-noticias", element: <NewsPage /> },
//         { path: "/links", element: <LinktreeCard /> },
//       ],
//     },
//   ]);

//   return <RouterProvider router={router} />;
// };

// ReactDOM.createRoot(document.getElementById("root")!).render(
//   <React.StrictMode>
//     <HelmetProvider>
//     <Routes />
//     </HelmetProvider>
//   </React.StrictMode>,
// );

import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { Suspense } from "react";

import "./index.css";

import { router } from "./router";

import { RouterProvider } from "react-router-dom";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <HelmetProvider>
      <Suspense fallback={null}>
        <RouterProvider router={router} />
      </Suspense>
    </HelmetProvider>
  </React.StrictMode>,
);
